exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".certificate-form-section[data-v-cfd79a9c]{width:100%;margin:0 0 1rem;padding-bottom:.5rem;border-bottom:1px solid #e5e7eb;color:#3f4254;font-weight:600}", ""]);

// exports
